import { useCurrentUser } from '@qualio/ui-components';
import { useMutation } from 'react-query';
import { documentApi } from '../../../../../api/document';

export const useSendForSequentialApproval = () => {
  const { companyId } = useCurrentUser();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (documentId: number) =>
      documentApi.sendForSequentialApproval(companyId, documentId),
  });

  return { sendForSequentialApproval: mutateAsync, isLoading };
};
